import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.4.1_@babel+core@7.25.2_react-dom@19.1.0_react@19.1.0__react@19.1.0_sass@1.79.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/AboutPage/AboutPage.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["ContactFooter"] */ "/vercel/path0/src/components/ContactFooter/ContactFooter.component.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/CopyBlock/CopyBlock.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Section/Section.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["ServicesMarquee"] */ "/vercel/path0/src/components/ServicesMarquee/ServicesMarquee.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Slide"] */ "/vercel/path0/src/components/Slide/Slide.component.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/StyledButton/StyledButton.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/icons/AfterAvenueBrandmark.svg");
